import {
    CALL_MESSAGE_NOTIFICATION,
    FETCH_ALL_MESSAGE_NOTIFICATIONS,
} from './actions';

export default function reducer(
    state = {
        isCallMessageNotification: true,
        messageNotifications: [],
    },
    action
) {
    switch (action.type) {
        case CALL_MESSAGE_NOTIFICATION:
            return {
                ...state,
                isCallMessageNotification: action.payload.data,
            };
        case FETCH_ALL_MESSAGE_NOTIFICATIONS:
            return {
                ...state,
                messageNotifications: action.payload.data,
            };
        default:
            return state;
    }
    // return state;
}
